<template>
    <div>
        tabla de resultado
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { phrases } from '@/data/phrases'  
 

export default {
    mounted(){
        this._setPhrase()
    },
    props: {
        user: {
            type: Object,
            required: false,
        }
    },
    mixins: [togglePasswordVisibility],    
    computed:{
        ...mapState('auth',['quote']),
        ...mapState('appConfig',['windowWidth']),
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
        myQuote(){
            return this.quote                 
        }
    },
    methods:{
        ...mapMutations('auth',['setPhrase']),
        login(){
            this.$emit('login-user', this.user)                                                            
        },
        _setPhrase(){
            this.setPhrase( phrases[ Math.floor(Math.random() * (20 - 1)) + 1 ] )
        }
    }
}
</script>


